import { useState } from 'react';
import { Alert, Form } from 'react-bootstrap';
import { adminSetUserRoles } from '../api';

// user_management_and_delivery_kyc.md - one account can hold several roles. Adding 'delivery'
// needs Aadhaar KYC + an address already on the account, so the backend may 400 - surfaced here.
// Shared by UserDetailsModal (full popup) and the Users-list "Roles" quick action.
export const ASSIGNABLE_ROLES = ['customer', 'owner', 'admin', 'delivery', 'finance_employee', 'finance_lead', 'finance_manager'];
const ROLE_LABEL = {
  customer: 'Customer', owner: 'Rental owner', admin: 'Website owner', delivery: 'Car driver',
  finance_employee: 'Finance (view)', finance_lead: 'Finance lead', finance_manager: 'Finance manager'
};

export default function UserRolesEditor({ user, onChanged, roleLabel }) {
  const labels = { ...ROLE_LABEL, ...(roleLabel || {}) };
  const initial = user?.effectiveRoles || (user?.role ? [user.role] : []);
  const [roles, setRoles] = useState(initial);
  const [saving, setSaving] = useState('');
  const [error, setError] = useState('');

  const toggle = async (role) => {
    const next = roles.includes(role) ? roles.filter((r) => r !== role) : [...roles, role];
    if (next.length === 0) return;
    setSaving(role);
    setError('');
    try {
      const updated = await adminSetUserRoles(user._id, next);
      setRoles(updated.effectiveRoles || updated.roles || next);
      onChanged?.(updated);
    } catch (err) {
      setError(err.response?.data?.msg || 'Could not change roles.');
    } finally {
      setSaving('');
    }
  };

  return (
    <>
      {error && <Alert variant="danger" className="py-2">{error}</Alert>}
      <div className="d-flex flex-wrap gap-3">
        {ASSIGNABLE_ROLES.map((r) => (
          <Form.Check
            key={r} type="checkbox" id={`role-${user._id}-${r}`} label={labels[r] || r}
            checked={roles.includes(r)}
            disabled={saving === r || (roles.length === 1 && roles[0] === r)}
            onChange={() => toggle(r)}
          />
        ))}
      </div>
    </>
  );
}
